import type { AIServerName } from '../interfaces';

export default function getAIRootURL(serverName: AIServerName): string {
  const hostname = globalThis?.location?.hostname ?? '';
  const hostnameWithoutSubdomain = hostname.split('.').slice(-2).join('.');

  const isDemoRoot = hostname === 'demo.openclassrooms.tech';
  const subdomain = isDemoRoot ? `${serverName}-demo` : serverName;

  return `https://${subdomain}.${hostnameWithoutSubdomain}`;
}
